import styled from 'styled-components';

export const Container = styled.div`
  min-width: ${({ theme }) => theme.spacing[64]};
`;
